/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description: summary
 * @Date: 2020-06-15 16:26:28
 */
import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    itemData: {},
    pagemeta: {},
  }),
  mutations: {
    [types.UPDATE_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_SUMMARY_DATA](state, itemData) {
      state.itemData = itemData;
    },
    [types.UPDATE_SUMMARY_PAGEMETA](state, pagemeta) {
      state.pagemeta = pagemeta;
    },
  },
  actions: {
    /**
     * 获取检索结果
     */
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, route.params, { routeName: route.name }, $params);
      Object.keys(params).forEach((key) => {
        params[key] = params[key].replace(/(?:<|>|alert|script|"|')/gi, '');
      });
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/summary`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));
      result = result && result.data;
      const { status, head = '', itemData, pagemeta } = result || {};
      if (status === 302) return result;
      if (status === 0 && itemData) {
        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_SUMMARY_DATA, itemData);
        commit(types.UPDATE_SUMMARY_PAGEMETA, pagemeta);
        return result;
      }
      commit(types.UPDATE_HEAD, '');
      commit(types.UPDATE_SUMMARY_DATA, {});
      commit(types.UPDATE_SUMMARY_PAGEMETA, {});

      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
